import { Pencil, Trash2 } from 'lucide-react';
import Button from './Button';

export interface TableActionsProps {
  onEdit: () => void;
  onDelete: () => void;
  editDisabled?: boolean;
  deleteDisabled?: boolean;
  editLabel?: string;
  deleteLabel?: string;
}

export default function TableActions({
  onEdit,
  onDelete,
  editDisabled = false,
  deleteDisabled = false,
  editLabel = 'Modifier',
  deleteLabel = 'Supprimer',
}: TableActionsProps) {
  return (
    <div className="flex justify-end gap-1">
      <Button
        variant="update"
        size="sm"
        disabled={editDisabled}
        onClick={onEdit}
        aria-label={editLabel}
        title={editLabel}
      >
        <Pencil className="h-4 w-4" />
      </Button>
      <Button
        variant="danger"
        size="sm"
        disabled={deleteDisabled}
        onClick={onDelete}
        aria-label={deleteLabel}
        title={deleteLabel}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
